export default () => ({
  accounts: null,
})
